.street-address-2-container {
    margin-bottom: 6px;
    width: fit-content;
}
